"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NumericInput = _interopRequireDefault(require("../NumericInput"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function CurrencyInput(_ref) {
  var className = _ref.className,
      label = _ref.label,
      value = _ref.value,
      min = _ref.min,
      max = _ref.max,
      step = _ref.step;
  return _react["default"].createElement(_NumericInput["default"], {
    className: className,
    label: label,
    min: min,
    max: max,
    step: step,
    value: value
  });
}

CurrencyInput.displayName = 'CurrencyInput';
CurrencyInput.propTypes = {
  className: _propTypes["default"].string,
  label: _propTypes["default"].string,
  value: _propTypes["default"].number,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  step: _propTypes["default"].number,
  currencyCode: _propTypes["default"].string
};
CurrencyInput.defaultProps = {
  className: '',
  min: 0,
  step: 0.01,
  currencyCode: 'USD'
};
var _default = CurrencyInput;
exports["default"] = _default;